
import type { FilterSection } from "@/types/filterTypes";
import jobTypesOptions from '@/utils/constants/jobTypesOptions';
    
export const useJobsFilterSections = (): FilterSection[] => {
  
  return [
    {
      key: "jobType",
      label: "Job Type",
      type: "select",
      options: jobTypesOptions
    },
    {
      key: "searchBy",
      label: "Search",
      type: "text",
    },
    {
      key: "isExpired",
      label: "Expired",
      type: "boolean",
    },

    {
      key: "createdStartDate",
      label: "Created At Start Date",
      type: "date",
      placeholder: "From"
    },
    {
      key: "createdEndDate",
      label: "Created At End Date",
      type: "date",
      placeholder: "To"
    },
    {
      key: "publishedStartDate",
      label: "Published At Start Date",
      type: "date",
      placeholder: "From"
    },
    {
      key: "publishedEndDate",
      label: "Published At End Date",
      type: "date",
      placeholder: "To"
    },
    {
      key: "deadLineStartDate",
      label: "Deadline Start Date",
      type: "date",
      placeholder: "From"
    },
    {
      key: "deadLineEndDate",
      label: "Deadline End Date",
      type: "date",
      placeholder: "To"
    }
  ];
};
